import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

import { NotificationModule } from '@agilent/ui-element';
import { TranslateModule } from '@ngx-translate/core';

import { AppComponent } from '@app/app.component';
import { LayoutsModule } from '@app/layouts/layouts.module';
import { AppRoutingModule } from '@app/app-routing.module';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AddUserComponent } from '@app/pages/users/add-user-component';
import { FormsModule } from '@angular/forms';
import { AddCidDialogComponent } from '@app/pages/acs/dialogs/add-cid-dialog.component';
import { AddCustomerComponent } from '@app/pages/customers/dialogs/add-customer-component';
import { AddOpenLabSystemComponent } from '@app/pages/openlab-systems/add-openlab-system-component';
import {
    NgbAccordionModule,
    NgbTooltipModule
} from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { AgTimeAgoModule } from '@app/shared/pipes/ag-time-ago/ag-time-ago.module';
import { ShadowDetailsComponent } from '@app/pages/acs/ac-details/ac-activity-logs/shadow-details/shadow-details.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AuthGuardService } from '@app/shared/auth-guard.service';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { SharedUiModule } from '@app/shared/ui/shared-ui.module';
import { AcNicConfigDialogComponent } from '@app/pages/acs/dialogs/ac-nic-config-dialog/ac-nic-config-dialog.component';
import { AcUserReasonDialogComponent } from '@app/pages/acs/dialogs/ac-user-reason-dialog/ac-user-reason-dialog.component';
import { ProgressDialogComponent } from '@app/shared/ui/progress-dialog.component';
import { WindowsImportDialogComponent } from '@app/shared/ui/windows-import-dialog.component';
import { RequiredSoftwareNotificationComponent } from '@app/pages/acs/dialogs/required-software-notification.component';

import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import { environment } from '@env/environment';
import { CognitoCallbackComponent } from '@app/cognito-callback.component';
import { OktaCallbackComponent } from '@app/okta-callback.component';
import { AicRemoteSessionDialogComponent } from '@app/pages/acs/dialogs/aic-remote-session-dialog.component';
import { SoftwareImageSelectionDialogComponent } from '@app/shared/ui/software-image-selection-dialog/software-image-selection-dialog.component';
import { InfoDialogComponent } from '@app/shared/ui/info-dialog.component';
import { IConfig, NgxMaskModule, } from 'ngx-mask';
import { LaunchSystemsAccessDialogComponent } from '@app/pages/acs/dialogs/launch-systems-access-dialog.component';
import { SharedTranslateModule } from '@agilent/common';
import { DeleteCidDialogComponent } from './pages/acs/dialogs/delete-cid-dialog.component';
import { AutoLogoutComponent } from '@app/pages/auto-logout/auto-logout.component';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
    declarations: [
        AppComponent,
        AddUserComponent,
        AddCidDialogComponent,
        AddCustomerComponent,
        AddOpenLabSystemComponent,
        ShadowDetailsComponent,
        AcNicConfigDialogComponent,
        AcUserReasonDialogComponent,
        ProgressDialogComponent,
        WindowsImportDialogComponent,
        RequiredSoftwareNotificationComponent,
        CognitoCallbackComponent,
        OktaCallbackComponent,
        AicRemoteSessionDialogComponent,
        SoftwareImageSelectionDialogComponent,
        LaunchSystemsAccessDialogComponent,
        DeleteCidDialogComponent,
        InfoDialogComponent,
        AutoLogoutComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        TranslateModule.forRoot(),
        SharedTranslateModule.forRoot(),
        NotificationModule.forRoot(),
        BrowserAnimationsModule,
        LayoutsModule,
        AppRoutingModule,
        NgbAccordionModule,
        AgTimeAgoModule,
        NgSelectModule,
        NgxJsonViewerModule,
        SharedUiModule,
        OktaAuthModule,
        NgxMaskModule.forRoot(),
        NgbTooltipModule
    ],
    providers: [
        DatePipe,
        AuthGuardService,
        { provide: OKTA_CONFIG, useValue: environment.oktaConfig },
    ],
    bootstrap: [AppComponent]

})
export class AppModule {
}
